var map = {
	"./adsky_logo.png": 275,
	"./boc_logo.png": 33,
	"./cf_logo.png": 468,
	"./commercial_bank_logo.png": 620,
	"./hutch_logo.png": 23,
	"./portfolio.png": 727,
	"./redleafstats.png": 669,
	"./sampath_bank_logo.png": 458,
	"./sdb_logo.png": 658,
	"./seylan_bank_logo.png": 972,
	"./shippyfee_logo.png": 470,
	"./toyota_lanka_logo.png": 503,
	"./wartex_logo.png": 314
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 247;